import * as types from "./action-types";
import BookmarksApi from "../../../../api/BookmarksApi";

export const fetchBookmarks = refresh => ({
	type: types.BOOKMARKS_GET,
	payload: BookmarksApi.fetchBookmarks()
});

export const openProfileSidePanel = () => ({
	type: types.OPEN_PROFILE
});

export { types as bookmarkActionTypes };



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/actions/index.js